import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowMinimize32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconArrowMinimize32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M18 15h8.5a1 1 0 1 0 0-2h-6.086l6.793-6.793a1 1 0 0 0-1.414-1.414L19 11.586V5.5h-1 1a1 1 0 1 0-2 0h1-1V15zM4.793 27.207a1 1 0 0 1 0-1.414L11.586 19H5.5a1 1 0 1 1 0-2H15v9.5h-2v-6.086l-6.793 6.793a1 1 0 0 1-1.414 0M14 26.5h1a1 1 0 1 1-2 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowMinimize32);
